export const getTabs = (): { label: string; name: string }[] => {
  return [
    { label: "Wszyscy", name: "all" },
    { label: "Aktywni", name: "active" },
    { label: "Nieaktywni", name: "deactivated" },
  ];
};
